var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "11 11 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.854 17.453 16.401 15l2.453-2.453a.494.494 0 0 0 0-.701l-.7-.701a.497.497 0 0 0-.702 0L15 13.598l-2.453-2.453a.496.496 0 0 0-.7 0l-.701.7a.494.494 0 0 0 0 .702L13.599 15l-2.453 2.453a.494.494 0 0 0 0 .701l.7.701a.496.496 0 0 0 .701 0L15 16.402l2.452 2.453a.497.497 0 0 0 .702 0l.7-.7a.494.494 0 0 0 0-.702"
})));
export default SvgXmark;